import FnspTreatmentBlock from './FnspTreatmentBlock';

globalThis.FnspTreatmentComponents = {
  FnspTreatmentBlock,
};
